export default __webpack_public_path__ + "static/media/photo--lg--chris-2.cf0c3566.jpg";